import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from "prop-types";

const PrivateRoute = ({ component: Component, ...rest }) => {

    const lmsToken = localStorage.getItem('lmsToken') || 11222;
    console.log(localStorage.getItem('lmsToken'));
    return (
        <Route {...rest} render={props => {
            if (lmsToken) { return <Component {...props} />; }
            window.location.href = process.env.REACT_APP_LMS_URL;
        }} />
    );
}

PrivateRoute.propTypes = {
    component: PropTypes.elementType
};

export default PrivateRoute;
